<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      :style="{
        'width': $q.screen.gt.xs ? '500px' : '100%',
        'max-width': '500px'
      }"
    >
      <q-form
        ref="formRef"
      >
        <q-card-section v-if="voucherSale">
          <div class="column">
            <div
              class="row items-center q-gutter-sm q-mx-xs"
              style="margin-bottom: 32px;"
            >
              <div class="col text-h6">
                {{ formTitle }}
              </div>
              <q-btn
                class="col-auto"
                icon="close"
                flat
                round
                dense
                @click="close"
              />
            </div>
            <div class="row q-col-gutter-sm items-start">
              <q-select
                v-if="!selectedVoucherPackage"
                v-model="selectedVoucherType"
                clearable
                class="col-12"
                label="Voucher Type"
                :options="$_.filter(voucherTypes.data, { forSale: true })"
                emit-value
                map-options
                :rules="[val => val !== null || 'Field is required']"
                bottom-slots
                @update:model-value="value => selectVoucherType(value)"
              >
                <template #selected-item="scope">
                  {{ scope.opt.name }}
                </template>
                <template #option="scope">
                  <q-item
                    v-bind="scope.itemProps"
                    v-on="scope.itemEvents"
                  >
                    <q-item-section>
                      {{ scope.opt.name }}
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-select
                v-if="!selectedVoucherType"
                v-model="selectedVoucherPackage"
                clearable
                class="col-12"
                label="Voucher Package"
                :options="$_.filter(voucherPackages.data)"
                emit-value
                map-options
                :rules="[val => selectedVoucherType || val !== null || 'Field is required']"
                bottom-slots
                @update:model-value="value => selectVoucherPackage(value)"
              >
                <template #selected-item="scope">
                  {{ scope.opt.name }}
                </template>
                <template #option="scope">
                  <q-item
                    v-bind="scope.itemProps"
                    v-on="scope.itemEvents"
                  >
                    <q-item-section>
                      {{ scope.opt.name }}
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <!-- NOTE: We must pass :model="sectionClone" to all of these for the reasons explained
            in the code comments for `initializeSectionClone()` -->
              <model-form-input
                :model="sectionClone"
                :field="`config.voucherSales[${index}].name`"
                value-type="String"
                class="col-12"
                label="Name"
                :rules="[val => !!val || 'Field is required']"
              />
            </div>
            <div
              class="row q-col-gutter-sm items-center"
            >
              <model-form-toggle
                :model="sectionClone"
                :field="`config.voucherSales[${index}].hasMinimumAmount`"
                value-type="Boolean"
                class="col-6 q-pb-md"
                label="Minimum Amount"
              />
              <model-form-input
                :model="sectionClone"
                :field="`config.voucherSales[${index}].minimumAmount`"
                value-type="Number"
                :disable="!voucherSale.hasMinimumAmount"
                class="col-6"
                label="Minimum Sale Amount"
                type="number"
                step="1"
                :rules="[val => !!val || 'Field is required']"
              />
            </div>
          </div>
        </q-card-section>
        <q-card-actions class="row justify-end q-ma-sm">
          <q-btn
            :label="formSaveLabel"
            color="primary"
            @click="save()"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { createVoucherSale } from 'src/models/voucher/VoucherSale'
import SectionConfigArrayElementFormMixin from 'src/modules/admin/components/ModelForm/mixins/SectionConfigArrayElementFormMixin'

export default {
  name: 'VoucherSaleForm',
  mixins: [SectionConfigArrayElementFormMixin],
  data () {
    return {
      selectedVoucherType: null,
      selectedVoucherPackage: null
    }
  },
  configuration: ['voucherTypes', 'voucherPackages'],
  computed: {
    // Required by mixin
    field () {
      return 'voucherSales'
    },
    // required by mixin
    typeName () {
      return 'Voucher Sale'
    },
    voucherSale () {
      return this.currentArrayElement
    }
  },
  watch: {
    voucherSale () {
      if (this.voucherSale) {
        if (this.voucherSale.voucherTypeId) {
          this.selectedVoucherType = _.find(this.voucherTypes.data, { id: this.voucherSale.voucherTypeId })
        } else {
          this.selectedVoucherPackage = _.find(this.voucherPackages.data, { id: this.voucherSale.voucherPackageId })
        }
      }
    }
  },
  methods: {
    // required by mixin
    getElementDefaultProps () {
      return createVoucherSale()
    },
    selectVoucherType (voucherType) {
      // If the voucherSale is using the default name (same as selectedVoucherType), update it to new default
      if (!this.voucherSale.name || this.voucherSale.name === this.selectedVoucherType.name) {
        this.voucherSale.name = voucherType.name
      }

      this.selectedVoucherType = voucherType
      this.voucherSale.voucherTypeId = voucherType.id
      this.voucherSale.voucherTypeName = voucherType.name
      this.voucherSale.voucherTypePrice = voucherType.price
    },
    selectVoucherPackage (voucherPackage) {
      // If the voucherSale is using the default name (same as selectedVoucherType), update it to new default
      if (!this.voucherSale.name || this.voucherSale.name === this.selectedVoucherPackage.name) {
        this.voucherSale.name = voucherPackage.name
      }

      this.selectedVoucherPackage = voucherPackage
      this.voucherSale.voucherPackageId = voucherPackage.id
      this.voucherSale.voucherTypeName = voucherPackage.name
      this.voucherSale.voucherTypePrice = voucherPackage.price
    }
  }
}
</script>
